import {AddressRegistryService} from "../_services/address-registry.service";
const addressService = new AddressRegistryService();

const state = {
  regions: [],
    countries: []
}

const actions = {
  fetchRegions ({ commit }) {
      addressService.getChildren(4948).then(data => {
      commit('SET_REGIONS', data)
    }).catch(err => console.log(err))
  },

    fetchCountries ({ commit }) {
        addressService.getCountries().then(data => {
            commit('SET_COUNTRIES', data)
        }).catch(err => console.log(err))
    },
}

const mutations = {
  SET_REGIONS (state, resp) {
    state.regions = resp
  },
  SET_COUNTRIES (state, resp) {
    state.countries = resp
  }
}

const getters = {
    regions: (state) => {
        return state.regions
    },

    countries: (state) => {
        return state.countries
    }
}

export const address = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
